import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { AMERICON_MARK } from '../../../shared/branding/americon';
import {
  canOpenStudioAmericonDashboardProduct,
  type StudioAmericonDashboardProduct,
} from '../../../shared/productLaunch/studioAmericonDashboardLaunch';

function readClientLaunchArgs() {
  return {
    hostname: typeof window !== 'undefined' ? window.location.hostname : undefined,
    port: typeof window !== 'undefined' ? window.location.port : undefined,
    viteDev: import.meta.env.DEV,
    env: {
      VITE_APT_STUDIO_PROD_PUBLISHED: import.meta.env.VITE_APT_STUDIO_PROD_PUBLISHED,
      VITE_AMERICON_PROD_PUBLISHED: import.meta.env.VITE_AMERICON_PROD_PUBLISHED,
    },
  };
}

/**
 * Blocks APT Studio / AmeriCon dashboard routes on production apex until
 * VITE_*_PROD_PUBLISHED=true. Dev hosts and Vite DEV still pass through.
 */
const StudioAmericonDashboardLaunchGate: React.FC<{
  product: StudioAmericonDashboardProduct;
  children: React.ReactNode;
}> = ({ product, children }) => {
  const navigate = useNavigate();
  const allowed = useMemo(
    () => canOpenStudioAmericonDashboardProduct(product, readClientLaunchArgs()),
    [product],
  );

  if (allowed) {
    return <>{children}</>;
  }

  const title = product === 'americon' ? AMERICON_MARK : 'APT Studio';
  const goDashboard = () => navigate('/dashboard', { replace: true });

  return (
    <Dialog open onClose={goDashboard} aria-labelledby="studio-americon-route-coming-soon-title">
      <DialogTitle id="studio-americon-route-coming-soon-title">Coming soon</DialogTitle>
      <DialogContent>
        <Typography>
          {title} is in final preparation and is not available on production yet.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={goDashboard} autoFocus>
          Back to dashboard
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StudioAmericonDashboardLaunchGate;
